import moment from 'moment-timezone';

export const tzToCountry: Record<string, { flag: string; code: string }> = {
  // United States 🇺🇸 (+1)
  'America/New_York': { flag: 'us', code: '1' },
  'America/Detroit': { flag: 'us', code: '1' },
  'America/Kentucky/Louisville': { flag: 'us', code: '1' },
  'America/Kentucky/Monticello': { flag: 'us', code: '1' },
  'America/Indiana/Indianapolis': { flag: 'us', code: '1' },
  'America/Indiana/Vincennes': { flag: 'us', code: '1' },
  'America/Indiana/Winamac': { flag: 'us', code: '1' },
  'America/Indiana/Marengo': { flag: 'us', code: '1' },
  'America/Indiana/Petersburg': { flag: 'us', code: '1' },
  'America/Indiana/Vevay': { flag: 'us', code: '1' },
  'America/Chicago': { flag: 'us', code: '1' },
  'America/Indiana/Tell_City': { flag: 'us', code: '1' },
  'America/Indiana/Knox': { flag: 'us', code: '1' },
  'America/Menominee': { flag: 'us', code: '1' },
  'America/North_Dakota/Center': { flag: 'us', code: '1' },
  'America/North_Dakota/New_Salem': { flag: 'us', code: '1' },
  'America/North_Dakota/Beulah': { flag: 'us', code: '1' },
  'America/Denver': { flag: 'us', code: '1' },
  'America/Boise': { flag: 'us', code: '1' },
  'America/Phoenix': { flag: 'us', code: '1' },
  'America/Los_Angeles': { flag: 'us', code: '1' },
  'America/Anchorage': { flag: 'us', code: '1' },
  'America/Juneau': { flag: 'us', code: '1' },
  'America/Sitka': { flag: 'us', code: '1' },
  'America/Metlakatla': { flag: 'us', code: '1' },
  'America/Yakutat': { flag: 'us', code: '1' },
  'America/Nome': { flag: 'us', code: '1' },
  'America/Adak': { flag: 'us', code: '1' },
  'Pacific/Honolulu': { flag: 'us', code: '1' },

  // Canada 🇨🇦 (+1)
  'America/Toronto': { flag: 'ca', code: '1' },
  'America/Montreal': { flag: 'ca', code: '1' },
  'America/Nipigon': { flag: 'ca', code: '1' },
  'America/Thunder_Bay': { flag: 'ca', code: '1' },
  'America/Iqaluit': { flag: 'ca', code: '1' },
  'America/Pangnirtung': { flag: 'ca', code: '1' },
  'America/Resolute': { flag: 'ca', code: '1' },
  'America/Atikokan': { flag: 'ca', code: '1' },
  'America/Rankin_Inlet': { flag: 'ca', code: '1' },
  'America/Winnipeg': { flag: 'ca', code: '1' },
  'America/Rainy_River': { flag: 'ca', code: '1' },
  'America/Regina': { flag: 'ca', code: '1' },
  'America/Swift_Current': { flag: 'ca', code: '1' },
  'America/Edmonton': { flag: 'ca', code: '1' },
  'America/Cambridge_Bay': { flag: 'ca', code: '1' },
  'America/Yellowknife': { flag: 'ca', code: '1' },
  'America/Inuvik': { flag: 'ca', code: '1' },
  'America/Dawson_Creek': { flag: 'ca', code: '1' },
  'America/Fort_Nelson': { flag: 'ca', code: '1' },
  'America/Whitehorse': { flag: 'ca', code: '1' },
  'America/Dawson': { flag: 'ca', code: '1' },
  'America/Vancouver': { flag: 'ca', code: '1' },
  'America/St_Johns': { flag: 'ca', code: '1' },
  'America/Goose_Bay': { flag: 'ca', code: '1' },
  'America/Halifax': { flag: 'ca', code: '1' },
  'America/Glace_Bay': { flag: 'ca', code: '1' },
  'America/Moncton': { flag: 'ca', code: '1' },
  'America/Blanc-Sablon': { flag: 'ca', code: '1' },

  // El Salvador 🇸🇻 (+503)
  'America/El_Salvador': { flag: 'sv', code: '503' },

  // Australia 🇦🇺 (+61)
  'Australia/Sydney': { flag: 'au', code: '61' },
  'Australia/Melbourne': { flag: 'au', code: '61' },
  'Australia/Brisbane': { flag: 'au', code: '61' },
  'Australia/Adelaide': { flag: 'au', code: '61' },
  'Australia/Perth': { flag: 'au', code: '61' },
  'Australia/Darwin': { flag: 'au', code: '61' },
  'Australia/Hobart': { flag: 'au', code: '61' },
  'Australia/Canberra': { flag: 'au', code: '61' },
  'Australia/Currie': { flag: 'au', code: '61' },
  'Australia/Broken_Hill': { flag: 'au', code: '61' },
  'Australia/Lindeman': { flag: 'au', code: '61' },
  'Australia/Lord_Howe': { flag: 'au', code: '61' },

  // Nepal 🇳🇵 (+977)
  // 'Asia/Katmandu': { flag: 'np', code: '977' },
};

const defaultTimezoneByCountry: Record<string, string> = {
  AU: 'Australia/Sydney',
};
const DEFAULT_TIMEZONE = 'America/Toronto';

export const getDefaultTimeZoneForCountry = (countryCode: string | undefined): string => {
  if (countryCode && defaultTimezoneByCountry[countryCode]) {
    return defaultTimezoneByCountry[countryCode];
  }
  return DEFAULT_TIMEZONE;
};

export const getTimeZoneOffset = (timeZone: string): string => {
  if (!moment.tz.zone(timeZone)) {
    throw new Error(`Invalid timezone: ${timeZone}`);
  }

  const currentTime = moment.tz(timeZone);

  const offsetMinutes = currentTime.utcOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const hours = Math.floor(Math.abs(offsetMinutes) / 60);
  const minutes = Math.abs(offsetMinutes) % 60;

  return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
